import { persistor, store } from '../store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { WidgetLayout } from './WidgetLayout'
import { WidgetProps } from 'types/widget'
import './../index.scss'
import { I18nProvider } from '../providers/I18nProvider'
import { RECAPTCHA_SITE_KEY } from '../config'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { getUserProps } from 'hooks/useUserId'
import AppContext from '../context/AppContext'

export const Widget = ({ serverApiUrl, ...props }: WidgetProps) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY} key={RECAPTCHA_SITE_KEY} useRecaptchaNet={true}>
      <I18nProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppContext.Provider value={{ serverApiUrl, ...props, ...getUserProps() }}>
              <WidgetLayout />
            </AppContext.Provider>
          </PersistGate>
        </Provider>
      </I18nProvider>
    </GoogleReCaptchaProvider>
  )
}
